// extracted by mini-css-extract-plugin
module.exports = {"controls":"_30HYTD","soloBtn":"_1wArbP","content":"_1_Gmkg","shine-lines":"XZqUTl"};